/**
 * Returns true if the subject is null
 * @param subject
 */
export default function isNull(subject) {
    return subject === null;
}
